import { FC, ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "../../services/redux/hooks";
import { fnDictGetIndex, fnDictHasIndex } from "../../services/shared";
import { AdminContextProps } from "../../types/admin";


interface ContextProviderProps {
    children: ReactNode;
    name: string;
}


interface Options {
    selectByName: (state: any, name: string) => any;
    updateAsyncAction: any;
    context: React.Context<AdminContextProps | undefined>;
    updateObjectAdditionalParams?: (name: string) => any; // for any extra fields in dispatch action
    readOnly?: boolean;
}
export const createContextProvider = ({
    selectByName,
    updateAsyncAction,
    context,
    updateObjectAdditionalParams,
    readOnly = false
}: Options): FC<ContextProviderProps> => {
    return ({ children, name }) => {
        const dispatch = useAppDispatch();
        const objectValues = useAppSelector(state => selectByName(state, name));
        const getObjectAttribute = (path: string) => {
            if (path=='.') {return objectValues}
            return fnDictGetIndex(objectValues, path);
        };

        const updateObjectAttribute = (path: string, value: any) => {
            if (readOnly || path=='.') {
                console.warn("Attempted to update read-only context");
                return;
            }
            const extra = updateObjectAdditionalParams ? updateObjectAdditionalParams(name) : {};
            dispatch(updateAsyncAction({ ...extra, keyaddress: path, keyvalue: value }));
        };

        const getObjectAttributeExists = (path: string) => {
            if (path=='.') {return !!objectValues}
            return fnDictHasIndex(objectValues, path);
        };

        return (
            <context.Provider value={{ getObjectAttribute, updateObjectAttribute, getObjectAttributeExists }}>
                {children}
            </context.Provider>
        );
    };
};
